<template>
    <div class="position-box">
        <div class="transaction-head">            
            <img class="icon" src="@/assets/trend_tabulate.png" @click="leftShow" alt="">
            <div class="text">{{symbol}}</div>
            <img class="icon" src="@/assets/hangqing.png" alt="" @click="kline(symbol)">            
        </div>
        <div class="scroll-box" @scroll="listenScroll">
            <div class="item1-box">
                <div class="icon icon1" :class="{active: tradeIdx == 1}" @click="trade(1)">{{this.$t('kxt.mr')}}</div>
                <div class="icon icon2" :class="{active: tradeIdx == 2}" @click="trade(2)">{{this.$t('kxt.mc')}}</div>            
                <div class="item1-right">
                    <p class="t1" :class="[ parseFloat(xianjia) < parseFloat(open) ?'red':'']">{{curPrice | toFixed}}</p>
                </div>
            </div>
            <div class="transaction-box">
                <div class="transaction-left">   
                    <div class="limit-box" @click="alertType">
                        <div>{{priceText}}</div>
                        <img class="icon" src="@/assets/down.png" alt="">
                    </div>
                    <div class="num-wrap" v-show="curPriceType == 0">
                        <div class="input-box xianjia"><input class="input" type="number" min="0" v-model="xianjia" :placeholder="$t('kxt.price_type')[0]" autocomplete="off"></div>
                        <div class="num-box">
                            <button class="btn" type="button" @click="jian">-</button>
                            <button class="btn" type="button" @click="add">+</button>
                        </div>
                    </div>  
                    <div class="price-box" v-show="curPriceType == 1"><input class="input" type="text" disabled readonly :placeholder="$t('kxt.scjg')"></div>               
                    <div class="table">
                        <div class="table-head">
                            <div class="num-box"><input type="number" class="input number" v-model="amount"  min="0" :placeholder="$t('kxt.sl')" @keyup="keyAmount()" autocomplete="off"></div>                                             
                            <div>{{symbol}}</div>
                        </div>                    
                    </div>
                     <div class="ky-money" v-show="tradeIdx == 1">                
                        <div class="ky-buy">{{this.$t("kxt.ky")}}  <span class="blue">{{usdt_money}} USDT </span></div>
                        <div class="mt10">≈ {{curCurrency}} {{currency}}</div>
                    </div>
                    <div class="ky-money" v-show="tradeIdx == 2">
                        <div>{{this.$t("kxt.ksell")}}  <span class="blue">{{currency_money}} {{currency}} </span></div>   
                        <div class="mt10">≈ {{curCurrency}} USDT</div>             
                    </div>
                    <div class="rate" v-show="tradeIdx == 1">{{this.$t("kxt.sxfl")}} {{chainData.buy_rate}}%</div>
                    <div class="rate" v-show="tradeIdx == 2">{{this.$t("kxt.sxfl")}} {{chainData.sell_rate}}%</div>
                    <div class="money">{{this.$t("kxt.jye")}} {{totalMoney}} USDT</div>
                    <button class="btn-buy" type="button" v-show="tradeIdx == 1" @click="sureBuy">{{this.$t('kxt.mr')}}</button>
                    <button class="btn-buy btn-sell" type="button" v-show="tradeIdx == 2" @click="sureBuy">{{this.$t('kxt.mc')}}</button>
                </div>
                <div class="transaction-right">
                    <ul class="ul-box">
                        <li class="list">{{this.$t('kxt.pk')}}</li>
                        <li class="list">{{this.$t('kxt.jg')}}</li>
                        <li class="list list-qty">{{this.$t('kxt.sl')}}</li>
                    </ul>
                    <ul class="cont1-box">
                        <li class="cont" v-for="(item,index) in sellArr" :key="index">
                            <div class="item">{{5-index}}</div>
                            <div class="item">{{item[0] | toFixed4}}</div>
                            <div class="item item-number">{{item[1] | toFixed4}}</div>
                            <div class="scroll" :style="{'width': (((item[1] * item[0]) /8000)  > 100 ? '100%' : ((item[1] * item[0]) /8000) + Math.random()*15 + '%')}"></div>
                        </li>                    
                    </ul>
                    <div class="line"></div>
                    <ul class="cont1-box">
                        <li class="cont cont2" v-for="(item,index) in buyArr" :key="index">
                            <div class="item">{{index+1}}</div>
                            <div class="item">{{item[0] | toFixed4}}</div>
                            <div class="item item-number">{{item[1] | toFixed4}}</div>
                            <div class="scroll2" :style="{'width': (((item[1] * item[0]) /8000)  > 100 ? '100%' : ((item[1] * item[0]) /8000) + Math.random()*15 + '%')}"></div>
                        </li>                    
                    </ul>
                </div>
            </div>            
            <div class="transaction-foot">
                <div class="cont-box">
                    <ul class="tab-box">                  
                        <li class="tab tab1" :class="{active: footIdx == 0}" @click="footTab(0)">{{this.$t("kxt.dqwt")}}</li>
                        <li class="tab tab1" :class="{active: footIdx == 1}" @click="footTab(1)">{{this.$t("kxt.lswt")}}</li>
                        <li class="tab" :class="{active: footIdx == 2}" @click="footTab(2)">{{this.$t("kxt.jj")}}</li>
                    </ul>                
                    <!-- 当前委托 -->
                    <ul class="table-body" v-show="footIdx == 0">
                        <li class="table-tr" v-for="(item,index) in curDeal" :key="index">
                            <div class="time-box"><span class="type mr" :class="{mc: item.currency_way == 2}">{{item.currency_way | sellType}}</span> <span class="text">{{item.currency_type | currencyType}}/USDT</span><span class="status cancle" @click="cheDan(item.id)">{{$t('kxt.cd')}}</span></div>
                            <div class="price-box"><div>{{$t("kxt.jyh")}} {{item.order_sn}}</div></div>
                            <div class="num-box"><div>{{$t("kxt.wtzl")}} {{item.use_num}} {{currency}}</div><div>{{$t("kxt.jye")}} {{(parseFloat(item.use_num)*parseFloat(item.now_price)).toFixed(4)}}</div></div>
                            <div class="price-box"><div>{{$t("kxt.wtjg")}} {{item.now_price}} USDT</div><div>{{$t("kxt.sxf")}} {{(parseFloat(item.use_num)*parseFloat(item.now_price)*(parseFloat(item.rate))/100).toFixed(4)}}</div></div>                      
                            <div class="price-box date-box"><div>{{item.create_time | timeTamp}}</div></div>
                        </li>                        
                    </ul>
                    <!-- 历史委托 -->
                    <ul class="table-body" v-show="footIdx == 1">
                        <li class="table-tr" v-for="(item,index) in historyDeal" :key="index">
                            <div class="time-box"><span class="type mr" :class="{mc: item.currency_way == 2}">{{item.currency_way | sellType}}</span> <span class="text">{{item.currency_type | currencyType}}/USDT</span><span class="status">{{item.status | statusText}}</span></div>
                            <div class="price-box"><div>{{$t("kxt.jyh")}} {{item.order_sn}}</div></div>
                            <div class="num-box"><div>{{$t("kxt.wtzl")}} {{item.use_num}} {{currency}}</div><div>{{$t("kxt.jye")}} {{(parseFloat(item.use_num)*parseFloat(item.now_price)).toFixed(4)}}</div></div>
                            <div class="price-box"><div>{{$t("kxt.wtjg")}} {{item.now_price}} USDT</div><div>{{$t("kxt.sxf")}} {{(parseFloat(item.use_num)*parseFloat(item.now_price)*(parseFloat(item.rate))/100).toFixed(4)}}</div></div>  
                            <div class="price-box date-box" v-if="item.status == 2 && item.true_price > 0"><div>{{$t("kxt.cjjg")}} {{item.true_price}} USDT</div><div>{{item.deal_time | timeTamp}}</div></div>  
                            <div class="price-box date-box" v-else><div>{{item.create_time | timeTamp}}</div></div>                                                
                        </li>                         
                    </ul>
                    <!-- 简介 -->
                    <div class="item2-box" v-show="footIdx == 2">
                        <div class="cont1" v-html="content"></div>                    
                    </div>
                    <!-- 暂无数据 -->
                    <no-data v-show="isNoData"></no-data>                 
                 </div>
            </div>        
        </div>  
        <!-- 左侧弹框  -->        
        <div class="alert-bz-wrap" v-show="isLeftShow">
            <ul class="alert-box">
                <li class="alert-li" @click="select('GDCC',1)">
                    <img class="icon" src="@/assets/gdcc.png" alt="">
                    <div class="text">GDCC/USDT</div>     
                    <div class="money" :class="[ parseFloat(gdccusdt.close) < parseFloat(gdccusdt.open) ?'red':'']">{{gdccusdt.close | toFixed4}}</div>              
                </li>                
                <li class="alert-li" @click="select('ETH',3)">
                    <img class="icon" src="@/assets/ETH.png" alt="">
                    <div class="text">ETH/USDT</div>
                    <div class="money" :class="[ parseFloat(ethusdt.close) < parseFloat(ethusdt.open) ?'red':'']">{{ethusdt.close | toFixed4}}</div>                           
                </li>  
                <li class="alert-li" @click="select('BTC',4)">
                    <img class="icon" src="@/assets/BTC.png" alt="">
                    <div class="text">BTC/USDT</div>   
                    <div class="money" :class="[ parseFloat(btcusdt.close) < parseFloat(btcusdt.open) ?'red':'']">{{btcusdt.close | toFixed4}}</div>                       
                </li>        
                <li class="alert-li" @click="select('TRX',5)">
                    <img class="icon" src="@/assets/TRX.png" alt="">
                    <div class="text">TRX/USDT</div>  
                    <div class="money" :class="[ parseFloat(trxusdt.close) < parseFloat(trxusdt.open) ?'red':'']">{{trxusdt.close | toFixed4}}</div>                         
                </li>                 
            </ul>            
        </div>        
        <div class="mask" v-show="isMask" @click="cancle"></div> 
        <!-- 支付设置 -->
        <div class="alert-pay" v-show="isPayShow">
            <div class="alert-head">
                {{this.$t('tips.zfts')}}                          
            </div>
            <div class="alert-btn" @click="payJump">{{this.$t('wdkj.sure')}}</div>
        </div>       
        <div class="alert-wrap2" v-show="isShow2">
            <div class="alert-head">
                {{this.$t('duihuang.ts')}}
                <img class="icon" src="@/assets/close.png" @click="close" alt="">
            </div>
            <div class="cont">{{btcmTips}}</div>
        </div>    
        <div class="mask3" v-show="isShow" @click="close2"></div> 
        <div class="pwd-alert-box" v-show="isShow">
            <div class="alert-head">{{$t('usdttb.qsrjymm')}}</div>
            <img class="close" src="@/assets/close.png" @click="close2" alt="">
            <ul class="pwd-box">
                <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>               
            </ul>
        </div> 
        <!-- 限价0，市价1弹窗 -->
        <div class="alert-xj-box" v-show="isXjShow">
            <div class="alert-item xj" :class="{active: curPriceType == 0}" @click="xjSelect(priceType[0],0)">{{priceType[0]}}</div>
            <div class="alert-item" :class="{active: curPriceType == 1}" @click="xjSelect(priceType[1],1)">{{priceType[1]}}</div>
            <div class="alert-item btn-cancle" @click="cancle">{{this.$t('duihuang.qx')}}</div>
        </div>
        <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">
        <nav-bar navName='transaction'></nav-bar>  
    </div>
</template>
<script>
import navBar from '@/components/NavBar.vue'
import noData from '@/components/noData.vue'
import loading from '@/components/loading.vue'
let vm = null;
let that;
export default {
    name: 'transaction',
    data () {
        return {
            lang: 'en',
            uid: '',
            token: '',
            id: '',
            priceText: '',
            priceType: [],
            curPriceType: 1,//0限价1市价
            widget: null,
            symbolInfo: null,
            tabIdx: 0,
            timeIdx: 5,
            footIdx: 0,
            isMore: false,
            isSdt: false,                   
            isNoData: false,
            isTop: false,
            message: '',//简介
            leftData: [],
            isMask: false,
            isLeftShow: false,//左侧币种弹窗
            leftIdx: 0,
            tabLeftIdx: 1, 
            histime: '', 
            newPrice: '0.00',
            updown: '0.000',            
            maxprice: '0.00',
            minprice: '0.00',
            volume: '',
            dayvom: '0.00', 
            buyArr: [],
            sellArr: [],
            curDeal: [], //当前委托,  
            historyDeal: [], //历史委托,  
            bailList: [],         
            isShow: false,
            isShow2: false,            
            isBuy: false,  
            isXjShow: false,  
            isCheDan: false,
            tradeIdx: 1,
            tradeType: 1,            
            symbol:'GDCC/USDT',           
            chainData: {},
            content: '',
            amount: '',   
            btcm: 1.5,
            usdt: 1,
            btc: '',
            eth: '',
            trx: '',
            curPrice: '0.0000',
            xianjia: '0.0000',
            open: '0.0000',
            curMoney: '',
            totalMoney: '0.0000',
            btc_money: '0.0000',
            btcm_money: '0.0000',
            usdt_money: '0.0000',
            eth_money: '0.0000',
            trx_money: '0.0000',            
            currency: 'GDCC',
            currency_money: 0,
            curCurrency: '',
            timeType: 2,
            currency_type: 1,         
            limit: 100,
            page1: 1,
            page2: 1,
            isPayShow: false,
            btcmTips: '',
            inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],
            mr: '',
            mc: '',   
            btcusdt: {},
            ethusdt: {},
            gdccusdt: {},
            trxusdt: {},
            timer: null,
            timer2: null,
            timer3: null,
            timestamp: 0     
        }
    },
    beforeCreate() {
        that = this;
    },
    created() { 
        vm = this;   
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token');        
        this.lang = localStorage.getItem('user_lang');
        this.timestamp = localStorage.getItem('timestamp') || 0;  
        this.currency_type = localStorage.getItem('currency_type') || 1;
        this.tradeIdx = this.tradeType = this.$route.query.buy || 1; 
        this.symbol = localStorage.getItem('symbol') || 'GDCC/USDT'; 
        this.mr = this.$t('kxt.mr');       
        this.mc = this.$t('kxt.mc'); 
        this.priceText = this.$t('kxt.price_type')[1]; 
        this.priceType = this.$t('kxt.price_type');        
    },
	mounted() {
        localStorage.setItem('currency_type',this.currency_type);          
        this.getMemberInfo();  
        this.getNewestcurrency(); 
        this.getChainData();  
        this.getKlineTen(); 
        this.getCurBailList();
        // this.check(); 
        this.getKlineTimeAll();     
        this.timer = setInterval(()=>{
            this.getNewestcurrency();           
            this.getKlineTen(); 
            // this.getCurBailList();
        },3000);   
        this.timer3 = setInterval(()=>{           
            this.getCurBailList();//当前委托
            this.getBailList();//历史委托
        },6000);    
	},
	methods: {
        getChainData(){
            let params = {
                uid: this.uid,
                token: this.token,                
                currency_type: this.currency_type
            }
            this.isLoad = true; 
            this.$ajax.post('/api/Klineview/getChainData',params).then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){
                    this.chainData = resData;      
                    this.content = this.contHtml(resData.content);                   
                }else{
                    this.$router.push('/login')                 
                }
                this.isLoad = false; 
            }).catch(function(err){
                console.log(err)
            })
        },
        getKlineTen(){
            let params = {
                uid: this.uid,
                token: this.token,                
                currency_type: this.currency_type
            }            
            this.$ajax.post('/api/Klineview/klineTen',params).then((res) => {                
                let resData = JSON.parse(res.data.data);                
                if(res.data.code == 200){
                    this.sellArr = resData.asks.slice(0,5);                    
                    this.buyArr = resData.bids.slice(0,5); 
                }else{
                    this.$router.push('/login')                 
                }                
            }).catch(function(err){
                console.log(err)
            })
        },
        getKlineXj(){
            let params = {
                uid: this.uid,
                token: this.token
            }            
            this.$ajax.post('/api/Klineview/klineTimeAll',params).then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){ 
                    if(this.symbol == 'GDCC/USDT'){
                        this.xianjia = (JSON.parse(resData.gdccusdt).close).toFixed(4); 
                        this.open = JSON.parse(resData.gdccusdt).open;
                    }else if(this.symbol == 'ETH/USDT'){
                        this.xianjia = (JSON.parse(resData.ethusdt).close).toFixed(4); 
                        this.open = JSON.parse(resData.ethusdt).open;
                    }else if(this.symbol == 'BTC/USDT'){
                        this.xianjia = (JSON.parse(resData.btcusdt).close).toFixed(4); 
                        this.open = JSON.parse(resData.btcusdt).open;
                    }else{
                        this.xianjia = (JSON.parse(resData.trxusdt).close).toFixed(4); 
                        this.open = JSON.parse(resData.trxusdt).open;
                    }                    
                }else{
                    this.$router.push('/login')                 
                }                
            }).catch(function(err){
                console.log(err)
            })
        },
        getKlineTimeAll(){
            let params = {
                uid: this.uid,
                token: this.token
            }            
            this.$ajax.post('/api/Klineview/klineTimeAll',params).then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){                    
                    this.btcusdt = JSON.parse(resData.btcusdt);
                    this.ethusdt = JSON.parse(resData.ethusdt); 
                    this.gdccusdt = JSON.parse(resData.gdccusdt); 
                    this.trxusdt = JSON.parse(resData.trxusdt); 
                    if(this.symbol == 'GDCC/USDT'){
                        this.curPrice = JSON.parse(resData.gdccusdt).close || ''; 
                        this.open = JSON.parse(resData.gdccusdt).open || 1;
                    }else if(this.symbol == 'ETH/USDT'){
                        this.curPrice = JSON.parse(resData.ethusdt).close || ''; 
                        this.open = JSON.parse(resData.ethusdt).open || 1;
                    }else if(this.symbol == 'BTC/USDT'){
                        this.curPrice = JSON.parse(resData.btcusdt).close || ''; 
                        this.open = JSON.parse(resData.btcusdt).open || 1;
                    }else{
                        this.curPrice = JSON.parse(resData.trxusdt).close || ''; 
                        this.open = JSON.parse(resData.trxusdt).open || 1;
                    }                    
                }else{
                    this.$router.push('/login')                 
                }                
            }).catch(function(err){
                console.log(err)
            })
        },
        getCurBailList(){//
            let params = {
                uid: this.uid,
                token: this.token,                
                currency_type: this.currency_type,
                currency_way: 0,
                status: 1,
                limit: this.limit,
                page: this.page1
            }            
            this.$ajax.post('/api/Bail/bailList',params).then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){
                    if(resData.length > 0){	    
                        if(this.page1 > 2){
                            this.curDeal = this.curDeal.concat(resData);
                        }else{
                            this.curDeal = resData;
                        } 
                        if(this.curDeal.length>0){
                            this.isNoData = false	
                        }else{
                            this.isNoData = true
                        }						
                        this.curDataLength = resData.length;	
                    }else{                        
                        this.isNoData = this.page1 > 1 ? false:true;					
                        this.curDataLength = resData.length;
                    }
                }else{
                    // this.$router.push('/login')                 
                }               
            }).catch(function(err){
                console.log(err)
            })
        },
        getBailList(){//历史
            let params = {
                uid: this.uid,
                token: this.token,                
                currency_type: this.currency_type,
                currency_way: 0,
                status: 2,
                limit: this.limit,
                page: this.page2
            }            
            this.$ajax.post('/api/Bail/bailList',params).then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){
                    if(resData.length > 0){	  
                        if(this.page2 > 2){
                            this.historyDeal = this.historyDeal.concat(resData);
                        }else{
                            this.historyDeal = resData;
                        }                      						
                        
                        if(this.historyDeal.length>0){
                            this.isNoData = false	
                        }else{
                            this.isNoData = true
                        }						
                        this.curDataLength = resData.length;	
                    }else{                        
                        this.isNoData = this.page2 > 1 ? false:true;					
                        this.curDataLength = resData.length;
                    }
                }else{
                    // this.$router.push('/login')                 
                }               
            }).catch(function(err){
                console.log(err)
            })
        },
        getMemberInfo(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/member/getMemberInfo',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){        
                    this.curMoney = resData.btcm_money;            
                    this.btc_money = resData.btc_money;   
                    this.btcm_money = resData.btcm_money; 
                    this.eth_money = resData.eth_money;   
                    this.usdt_money = resData.usdt_money;  
                    this.trx_money = resData.trx_money || '0.0000'; 
                    this.getCurrency();                       
                }else{
                    this.$toast.bottom(res.data.msg);                    
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },  
        cheDan(id){            
            // this.isShow = true;
            this.id = id;
            this.isCheDan = true;
            let params = {
                uid: this.uid,
                token: this.token,
                id: this.id,
                // money_password: password
            }                          
            this.$ajax.post('/api/Bail/bailCancel',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                    this.isCheDan = false;
                    // this.isMask = false;
                    // this.isShow = false;                            
                    // this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];  
                    this.$toast.bottom(res.data.msg); 
                    this.page1 = 1;
                    this.page2 = 1;
                    this.curDeal = [];
                    this.historyDeal = []; 
                    this.getCurBailList();    
                    this.getBailList();                       
                }else if(res.data.code == 40016){
                    // this.isMask = true;
                    // this.isShow2 = true; 
                    this.btcmTips = res.data.msg;               
                }else if(res.data.code == 40006){
                    // this.isMask = true;
                    // this.isShow = true;                         
                    this.$toast.bottom(res.data.msg);  
                    // this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];            
                }else{
                    // this.isMask = false;
                    // this.isShow = false;                         
                    this.$toast.bottom(res.data.msg);  
                    // this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];       
                }
            }).catch(function(err){
                console.log(err);                
            })  
        },
        getNewestcurrency(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/miningmachine/newestcurrency',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                    this.btcm = resData.local_currency;
                    this.btc = resData.btc;
                    this.eth = resData.eth;
                    this.trx = resData.trx;   
                    this.getCurrency();                 
                }else if(res.data.code == 20001){
                    this.$router.push('/login');
                }else{
                    this.$toast.bottom(res.data.msg);                    
                }
            }).catch(function(err){
                console.log(err);                
            })     
        }, 
        getCurrency(){
            if(this.currency == 'BTC'){
                this.currency1 = this.btc; 
                this.currency_money = this.btc_money
            }else if(this.currency == 'GDCC'){
                this.currency1 = this.btcm;  
                this.currency_money = this.btcm_money;
            }else if(this.currency == 'ETH'){
                this.currency1 = this.eth;  
                this.currency_money = this.eth_money;
            }else if(this.currency == 'USDT'){
                this.currency1 = this.usdt;  
                this.currency_money = this.usdt_money; 
            }else if(this.currency == 'TRX'){
                this.currency1 = this.trx;  
                this.currency_money = this.trx_money;
            }else{
                 this.currency1 = this.usdt;
                 this.currency_money = this.usdt_money;
            }            
            if(this.tradeType == 1 && this.currency1){
                let buy_rate = parseFloat(this.chainData.buy_rate) || 1;
                this.curCurrency = (parseFloat(this.usdt_money)/(parseFloat(this.currency1) * (1 + buy_rate/100))).toFixed(4);                 
            }else if(this.tradeType == 2 && this.currency1){
                let sell_rate = parseFloat(this.chainData.sell_rate) || 1;
                this.curCurrency = (parseFloat(this.currency_money)*(parseFloat(this.currency1) * (1 - sell_rate/100))).toFixed(4);  
            }            
        },
        check(){//检测是否设置提现密码
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/Member/checkMoneyPass',params).then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){                                  
                    this.isPay = false;                                            
                }else{                                   
                    this.isPay = true;                                     
                }
            }).catch(function(err){
                console.log(err)
            })
        },  
        buy(){
            if(this.curPriceType == 1){
                let params = {
                    uid: this.uid,
                    token: this.token,
                    currency_type: this.currency_type,
                    currency_way: this.tradeType,
                    money: this.amount,                    
                    // money_password: password,
                    amount: ''
                }                          
                this.$ajax.post('/api/Bail/bailTransaction',params).then((res) => {                
                    let resData = res.data.data; 
                    if(res.data.code == 200){
                        this.isBuy = false;
                        this.isMask = false;
                        this.isShow = false;  
                        this.amount = '';
                        this.page1 = 1;
                        this.page2 = 1;
                        this.curDeal = [];
                        this.historyDeal = [];
                        if(this.tradeType == 1){
                            this.$toast.bottom(this.$t('duihuang.wtcg'));
                            this.getCurBailList();  
                            this.getBailList();     
                        }else{
                            this.$toast.bottom(this.$t('duihuang.wtcg'));
                            this.getBailList();     
                        }                        
                        this.getMemberInfo(); 
                        this.timer3 = setInterval(()=>{           
                            this.getCurBailList();//当前委托
                            this.getBailList();//历史委托
                        },6000); 
                    }else if(res.data.code == 40016){                        
                        this.btcmTips = res.data.msg;               
                    }else if(res.data.code == 40006){                                             
                        this.$toast.bottom(res.data.msg);                                
                    }else{                                              
                        this.$toast.bottom(res.data.msg);                               
                    }
                }).catch(function(err){
                    console.log(err);                
                })   
            }else{//限价
                let params = {
                    uid: this.uid,
                    token: this.token,
                    currency_type: this.currency_type,
                    currency_way: this.tradeType,
                    money: this.amount,                    
                    // money_password: password,
                    amount: this.xianjia
                }                          
                this.$ajax.post('/api/Bail/bailTransaction',params).then((res) => {                
                    let resData = res.data.data; 
                    if(res.data.code == 200){
                        this.isBuy = false;
                        this.isMask = false;
                        this.isShow = false; 
                        this.amount = ''; 
                        this.page1 = 1;
                        this.page2 = 1;
                        this.curDeal = [];
                        this.historyDeal = [];
                        if(this.tradeType == 1){
                            this.$toast.bottom(this.$t('duihuang.wtcg'));
                            this.getCurBailList();  
                            this.getBailList();     
                        }else{
                            this.$toast.bottom(this.$t('duihuang.wtcg'));
                            this.getBailList();     
                        }
                        this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}]; 
                        this.getMemberInfo(); 
                    }else if(res.data.code == 40016){                        
                        this.btcmTips = res.data.msg;               
                    }else if(res.data.code == 40006){                                              
                        this.$toast.bottom(res.data.msg);                              
                    }else{                                              
                        this.$toast.bottom(res.data.msg);                               
                    }
                }).catch(function(err){
                    console.log(err);                
                })  
            } 
        },
        nextFocus(el,index) {
            var dom = document.getElementsByClassName("pwd-input"),
                currInput = dom[index],
                nextInput = dom[index + 1],
                lastInput = dom[index - 1];
            /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
            if (el.keyCode != 8) {
                if (index < (this.inputList.length - 1)) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            }else{
                if (index != 0) {
                    lastInput.focus();
                }
            }
            let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
            if(password.length == 6){                
                if(this.isCheDan){
                    
                }else{
                    if(this.curPriceType == 1){
                        let params = {
                            uid: this.uid,
                            token: this.token,
                            currency_type: this.currency_type,
                            currency_way: this.tradeType,
                            money: this.amount,                    
                            money_password: password,
                            amount: ''
                        }                          
                        this.$ajax.post('/api/Bail/bailTransaction',params).then((res) => {                
                            let resData = res.data.data; 
                            if(res.data.code == 200){
                                this.isBuy = false;
                                this.isMask = false;
                                this.isShow = false;  
                                this.amount = '';
                                this.page1 = 1;
                                this.page2 = 1;
                                this.curDeal = [];
                                this.historyDeal = [];
                                if(this.tradeType == 1){
                                    this.$toast.bottom(this.$t('duihuang.wtcg'));
                                    this.getCurBailList();  
                                    this.getBailList();     
                                }else{
                                    this.$toast.bottom(this.$t('duihuang.wtcg'));
                                    this.getBailList();     
                                }
                                this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}]; 
                                this.getMemberInfo(); 
                            }else if(res.data.code == 40016){
                                this.isMask = true;
                                this.isShow2 = true; 
                                this.btcmTips = res.data.msg;               
                            }else if(res.data.code == 40006){
                                this.isMask = true;
                                this.isShow = true;                         
                                this.$toast.bottom(res.data.msg);  
                                this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];            
                            }else{
                                this.isMask = false;
                                this.isShow = false;                         
                                this.$toast.bottom(res.data.msg);  
                                this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];       
                            }
                        }).catch(function(err){
                            console.log(err);                
                        })   
                    }else{//限价
                        let params = {
                            uid: this.uid,
                            token: this.token,
                            currency_type: this.currency_type,
                            currency_way: this.tradeType,
                            money: this.amount,                    
                            money_password: password,
                            amount: this.xianjia
                        }                          
                        this.$ajax.post('/api/Bail/bailTransaction',params).then((res) => {                
                            let resData = res.data.data; 
                            if(res.data.code == 200){
                                this.isBuy = false;
                                this.isMask = false;
                                this.isShow = false; 
                                this.amount = ''; 
                                this.page1 = 1;
                                this.page2 = 1;
                                this.curDeal = [];
                                this.historyDeal = [];
                                if(this.tradeType == 1){
                                    this.$toast.bottom(this.$t('duihuang.wtcg'));
                                    this.getCurBailList();  
                                    this.getBailList();     
                                }else{
                                    this.$toast.bottom(this.$t('duihuang.wtcg'));
                                    this.getBailList();     
                                }
                                this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}]; 
                                this.getMemberInfo(); 
                            }else if(res.data.code == 40016){
                                this.isMask = true;
                                this.isShow2 = true; 
                                this.btcmTips = res.data.msg;               
                            }else if(res.data.code == 40006){
                                this.isMask = true;
                                this.isShow = true;                         
                                this.$toast.bottom(res.data.msg);  
                                this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];            
                            }else{
                                this.isMask = false;
                                this.isShow = false;                         
                                this.$toast.bottom(res.data.msg);  
                                this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];       
                            }
                        }).catch(function(err){
                            console.log(err);                
                        })  
                    } 
                }
            }else{
                return false;
            }
        },
        // 滚动到页面顶部
        scrollTo() {            
             $('.scroll-box').animate({scrollTop:'0px'},'slow');
        },  
        listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;            
            if(ele.scrollTop > 100){
                this.isTop = true
            }else{
                this.isTop = false
            }					
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    if(this.footIdx == 0){
                        this.page1 ++;
                        this.getCurBailList(); 
                    }else if(this.footIdx == 1){
                        this.page2 ++;
                        this.getBailList(); 
                    }                     
                    clearInterval(this.timer3);
                    this.timer3 = null;                                  
                }						
            }
        },
        keyAmount(){
            this.amount = this.amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
			this.amount = this.amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
			this.amount = this.amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
			this.amount = this.amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
			if (this.amount.indexOf(".") < 0 && this.amount != "") { //首位是0的话去掉
				this.amount = parseFloat(this.amount);				
			}		
		},  
        trade(idx){
            this.tradeIdx = idx;     
            this.tradeType = idx;  
            this.getCurrency();   
            this.getKlineXj();            
        },
        kline(symbol){            
            this.$router.push('/kline');            
        },
        toFixed(v) {
            return parseFloat(v).toFixed(4)
        },        
        select(bz,type){ 
            this.tabIdx = 0;
            this.updown = '0.000';
            this.buyArr = [];
            this.sellArr = [];
            this.curDeal = [];
            this.historyDeal = [];
            this.page1 = 1;
            this.page2 = 1;
            this.currency = bz;
            this.symbol = bz + '/USDT';
            this.isLeftShow = false;
            this.isMask = false;
            this.currency_type = type;
            localStorage.setItem('currency_type',type);
            localStorage.setItem('symbol',bz + '/USDT');
            this.getCurrency(); 
            this.getKlineXj();  
            this.getKlineTen();
            this.getCurBailList();           
            this.getBailList();  
            this.getChainData();          
        },        
        leftShow(){
            this.isLeftShow = true;  
            this.isMask = true;
            this.timer2 = setInterval(()=>{                
                this.getKlineTimeAll();                
            },3000); 
        },
        payJump(){
            this.isPay = false;
            this.isMask = false;
            this.$router.push('/ModifyCashPwd');
        }, 
        jian(){ 
            var num = Number(this.xianjia);
            num = (num * 10 * 10 * 10 * 10);            
            num -= 1;            
            num = ((Number(num)) / 10000).toFixed(4)            
            if (num <= 0) {
                num = 0;
            }  
            this.xianjia = num;          
        },
        add(){
            var num = Number(this.xianjia);
            num = (num * 10 * 10 * 10 * 10);            
            num += 1;            
            num = ((Number(num)) / 10000).toFixed(4)           
            this.xianjia = num;
        },
        alertType(){
            this.isXjShow = true; 
            this.isMask = true;         
        },
        sureBuy(){
            if(this.amount == '' || this.amount == null || this.xianjia == '' || this.xianjia == null){
                this.$toast.bottom(this.$t('duihuang.qtxje'));  
                return false;
            }            
            if(this.tradeType == 1){
                if(this.amount > parseFloat(this.curCurrency)){
                    this.$toast.bottom(this.$t('duihuang.yebz'));
                    return false;  
                }  
                this.buy();                  
            }else{
                if(this.amount > parseFloat(this.currency_money)){
                    this.$toast.bottom(this.$t('duihuang.ksslbz'));  
                    return false;
                }    
                this.buy();
            }         
            // this.isShow = true;
        },        
        footTab(idx){
            this.footIdx = idx;
            this.page1 = 1;
            this.page2 = 1;
            this.content = '';  
            this.curDeal = [];
            this.historyDeal = [];
            if(idx == 0){
                this.curDeal = this.curDeal.filter((item,index) =>{
                    return item.status == 1;
                });  
                if(this.curDeal.length>0){
                    this.isNoData = false	
                }else{
                    this.isNoData = true
                }  
                this.getCurBailList();   
            }else if(idx == 1){
                this.historyDeal = this.historyDeal.filter((item,index) =>{
                    return item.status == 2 || item.status == 3;
                });  
                if(this.historyDeal.length>0){
                    this.isNoData = false	
                }else{
                    this.isNoData = true
                } 
                this.getBailList();        
            }else{
                this.getChainData();
                this.isNoData = false;
            }             
        },
        contHtml(str){
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, "''");  
            str = str.replace(/&#039;/g, "'");                
            return str; 
        },
        xjSelect(obj,curPriType){            
            this.priceText = obj;           
            this.curPriceType = curPriType;            
            this.isXjShow = false;  
            this.isMask = false;
            this.getKlineXj();
        },
        cancle(){           
            this.isLeftShow = false; 
            this.isBuy = false;   
            this.isPayShow = false;
            this.isXjShow = false;
            this.isMask = false;   
        }, 
        close(){ 
            this.isShow2 = false;      
            this.isBuy = false;
            this.isMask = false;
        },
        close2(){      
            this.isShow = false;    
            this.isCheDan = false;  
            this.isMask = false;  
            this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];     
        },
    },
    watch: {
        curPrice: function(val){   
            var amount = this.amount || 0; 
            var curPrice = parseFloat(val)       
            if(val > 0 && amount > 0){
                if(this.tradeType == 1){
                    this.totalMoney = (parseFloat(amount) * parseFloat(curPrice) * (1 + parseFloat(this.chainData.buy_rate)/100)).toFixed(4)                    
                }else{
                   this.totalMoney = (parseFloat(amount) * parseFloat(curPrice) * (1 - parseFloat(this.chainData.sell_rate)/100)).toFixed(4)
                }
            }else{
                this.totalMoney = 0.0000;  
            }            
        }, 
        amount: function(val){   
            var amount = val; 
            var curPrice = this.curPrice       
            if(val > 0){
                if(this.tradeType == 1){
                    this.totalMoney = (parseFloat(amount) * parseFloat(curPrice) * (1 + parseFloat(this.chainData.buy_rate)/100)).toFixed(4)                    
                }else{
                   this.totalMoney = (parseFloat(amount) * parseFloat(curPrice) * (1 - parseFloat(this.chainData.sell_rate)/100)).toFixed(4)
                }
            }else{
                this.totalMoney = 0.0000;  
            }            
        }       
    },    
    filters:{
        subStr1(val){
            return val.substring(5, 10);
        },
        subStr2(val){
            return val.substring(11, 19);
        },
        toFixed: function (value) {
            value = Number(value);
            return value.toFixed(4);
        },
        toFixed2: function (value) {
            value = Number(value);
            return value.toFixed(3);
        },
        toFixed4: function (value, options) {
            if(value){
                value = Number(value);
                return value.toFixed(4);
            }else{
                return ''
            }
        },
        statusText: function(val){
            var value = Number(val);
            if(value == 2){
                return vm.$t('kxt.ycj');
            }else{
                return vm.$t('kxt.wtcd');
            }
        },
        sellType: function(val){
            var value = Number(val);
            if(value == 1){
                return vm.mr;
            }else{
                return vm.mc;
            }
        },
        currencyType: function(val){           
            if(val == 1){
                return 'GDCC';
            }else if(val == 3){
                return 'ETH';
            }else if(val == 4){
                return 'BTC';
            }else if(val == 5){
                return 'TRX';
            }
        },
        timeTamp: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();            
            return Y + M + D + " " + h + m + s;
        },    
        // timeTamp: function (timestamp, options) {
        //     var date = new Date(timestamp*1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        //     var Y = date.getFullYear() + '-';
        //     var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        //     var D = date.getDate() > 9 ? date.getDate() + ' ' : ('0' + date.getDate()) + ' ';
        //     var h = date.getHours() > 9 ? date.getHours() + ':' : ('0' + date.getHours()) + ':';
        //     var m = date.getMinutes() > 9 ? date.getMinutes() + ':' : ('0' + date.getMinutes()) + ':';
        //     var s = date.getSeconds() > 9 ? date.getSeconds() : ('0' + date.getSeconds());
        //     return Y + M + D + h + m + s;
        // }
    },
    components:{
        navBar,
        noData,        
        loading       
    },
    beforeDestroy(){		
        clearInterval(this.timer);
        clearInterval(this.timer2);
        clearInterval(this.timer3);
        this.timer = null;
        this.timer2 = null;
        this.timer3 = null;
    }  
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #d0d0d0;
        font-size: .24rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url('../assets/element-background.png') no-repeat center center;  
        background-size: cover;
    }
    .scroll-box{
        position: absolute;
        top: 40px;
        bottom: 55px;
        width: 100%;
        height: auto;
        color: #fff;   
        overflow-y: auto;
    }
    .transaction-head{
        position: fixed;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center; 
        width: 100%;
        height: 40px;
        padding: 0 16px 0 12px;
        color: #fff;
        font-size: 16px;
        line-height: 40px;
        background: transparent;
        box-sizing: border-box;
    }
    .transaction-head .icon{
        width: 18px;
        height: 18px;
    }
    .transaction-head .text{
        flex: 1;
        padding: 0 18px;
    }
    .item1-box {
        display: flex;
        align-items: center;
        padding: .48rem .16rem .08rem;       
    }
    .cont-box .table-body .table-tr{   
        margin-top: .1rem;    
        padding: .2rem;
        color: #e2e2e2;
        font-size: .26rem;
        background: rgba(22, 35, 53,.6);
    }
    .cont-box .table-body .time-box{
        display: flex;
        align-items: center;
        margin-bottom: .1rem;
    }
    .cont-box .table-body .type{
        display: inline-block;
        padding: .02rem .06rem;
        color: #fff;
        font-size: .24rem;
        border-radius: .04rem;
    }
    .cont-box .table-body .type.mr{
        background: #00B464;
    }
    .cont-box .table-body .type.mc{
        background: #FA4D56;
    }
    .cont-box .table-body .text{
        flex: 1;
        padding: 0 .1rem;
    }
    .cont-box .table-body .status{
        margin-left: .3rem;   
        color: #2CAADE;
    }
    .cont-box .table-body .cancle{
        padding: .08rem .12rem;
        color: #218adc;        
        border: 1px solid #218adc;
        border-radius: 4px;
    }
    .cont-box .table-body .num-box{
        display: flex;
        justify-content: space-between;
        padding-top: .2rem;
    }
    .cont-box .table-body .price-box,.cont-box .table-body .rate-box{
        display: flex;
        justify-content: space-between;
        padding-top: .1rem;
    }     
    .cont-box .item2-box .cont1{
        padding: .2rem .24rem;
        color: #e2e2e2;     
        font-size: .26rem;           
    }
    .cont-box .item2-box .ul-box{   
        padding: 12px 12px 18px;
        background: #162335;
    }
    .cont-box .item2-box .ul-box .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: .36rem;
        color: #fff;
    }
    .cont-box .item2-box .ul-box .list:last-child{
        margin-bottom: 0;
    }
    .cont-box .item2-box .ul-box .list .t1{
        padding-right: .12rem;
        color: #7286a7;
        font-size: .28rem;
    }
    .cont-box .item2-box .ul-box .list .t2{
        flex: 1;
        text-align: right;
    }
    .item1-box .icon{
        width: 1.68rem;
        height: .48rem;
        color: #fff;
        font-size: .28rem;
        line-height: .48rem;
        text-align: center;
    }
    .item1-box .icon.icon1{
        background: url("../assets/coin_left_gray.png") no-repeat center center;
        background-size: cover;
    }
    .item1-box .icon1.active{
        background: url("../assets/coin_left_green.png") no-repeat center center;
        background-size: cover;
    }
    .item1-box .icon.icon2{
        margin-left: 10px;
        background: url("../assets/coin_right_gray.png") no-repeat center center;
        background-size: cover;
    }
    .item1-box .icon2.active{
        margin-left: 10px;
        background: url("../assets/coin_right_red.png") no-repeat center center;
        background-size: cover;
    }
    .item1-box .item1-right{
        flex: 1;
        text-align: right;
    }
    .item1-box .item1-right .t1{
        color: #00B464;
        font-weight: bold;
    }
    .item1-box .item1-right .t2{
        margin-top: .12rem;
        color: #7f7f7f;
    }
    .transaction-box{
        display: flex;
        justify-content: space-between;
        align-items: stretch;        
    }
    .transaction-box .transaction-left{
        flex: 1;
        padding: .28rem .16rem .44rem .16rem;
    }
    .transaction-box .transaction-left .limit-box{
        display: flex;
        align-items: center;
        font-size: .26rem;
    }
    .transaction-box .transaction-left .limit-box .icon{
        margin-left: .16rem;
        width: .24rem;
        height: .2rem;
    }
    .transaction-box .transaction-left .num-wrap{
        display: flex;
        align-items: center;
        padding: .36rem 0 .4rem;   
        background: transparent;     
    }    
    .transaction-box .transaction-left .ky-money,.transaction-box .transaction-left .rate,.transaction-box .transaction-left .money{
        margin-top: .2rem;
        color: #7f7f7f;
        font-size: .26rem;
    }
    .transaction-box .transaction-left .input-box{
        flex: 1;
        /* border-right: 1px solid #ddd; */
    }
    .transaction-box .transaction-left .num-wrap .input{
        width: 100%;
        height: .6rem;
        padding: 0 4px;
        color: #fff;
        font-size: .32rem;
        line-height: .6rem;
        background: rgba(19, 30, 48,.5);
        box-sizing: border-box;
    }
    .transaction-box .transaction-left .num-box{
        display: flex;
        align-items: center;
    }
    .transaction-box .transaction-left .num-wrap .btn{
        display: block;
        width: .6rem;
        height: .6rem;
        color: #fff;
        font-size: .32rem;
        font-weight: bold;
        line-height: .6rem;
        background: rgba(19, 30, 48,.5);
    }
    .transaction-box .transaction-left .price{
        color: #7f7f7f;
        font-size: .26rem;
    }
    .transaction-box .transaction-left .price-box{
        margin: .4rem 0 .24rem;
    }
    .transaction-box .transaction-left .price-box .input{
        width: 100%;
        height: .76rem;
        color: #666;
        line-height: .76rem;
        background: #19293F;
        text-align: center;
        box-sizing: border-box;
    }   
    .transaction-box .transaction-left .table .table-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 4px;
        color: #a3a3a3;
        font-size: .24rem;
        border: 1px solid #666;
    }
    .transaction-box .transaction-left .table-head .num-box{
        flex: 1;
    }
    .transaction-box .transaction-left .table-head .num-box .input{
        width: 100%;  
        color: #fff;
        font-size: .24rem;
        background: transparent;
    }
    .transaction-box .transaction-left .table .table-body{
        display: flex;
        justify-content: space-between;
        align-items: center;   
        opacity: 0; 
    }
    .transaction-box .transaction-left .table .td{
        width: 25%;
        padding: 6px 0;
        color: #a3a3a3;
        font-size: .26rem;
        border-right: 1px solid #d7d7d7;
        text-align: center;
    }
    .transaction-box .transaction-left .table .td:last-child{
        border-right: none;
    }
    .transaction-box .transaction-left .trade{
        margin-top: 16px;
        color: #7f7f7f;
        font-size: .28rem;
    }
    .transaction-box .transaction-left .btn-buy{
        display: block;
        width: 100%;
        height: .6rem;
        margin-top: .4rem;
        color: #fff;
        border-radius: 4px;
        background: #00B464;
        text-align: center;
    }
    .transaction-box .transaction-left .btn-sell{
        background: #FA4D56;
    }
        
    .transaction-box .transaction-right{
        flex: 1;
    }
    .transaction-box .transaction-right .ul-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: .28rem;
        color: #7f7f7f;
    }
    .transaction-box .transaction-right .ul-box .list{
        flex: 1;
        color: #7286A7;
        font-size: .26rem;
        text-align: center;
    }
    .transaction-box .transaction-right .ul-box .list-qty{
        flex: 1.5;
    }
    .transaction-box .transaction-right .line{
        margin: .28rem .28rem 0;
    }
    .transaction-box .transaction-right .cont1-box .cont{
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 8px;
        color: #d85656;
        font-size: .24rem;
    }
    .transaction-box .transaction-right .cont1-box .cont2 .item{
        color: #00c483;
    }
    .transaction-box .transaction-right .cont1-box .scroll{
        position: absolute;
        right: 0;
        z-index: -1;
        width: 0%;
        height: .3rem;
        background: #232435;
    }
    .transaction-box .transaction-right .cont1-box .scroll2{
        position: absolute;
        right: 0;
        z-index: -1;
        width: 0%;
        height: .3rem;
        background: rgba(0, 196, 131,.3);
    }
    .transaction-box .transaction-right .cont1-box .item{
        flex: 1;
        color: #d85656;
        text-align: center;
    }
    .transaction-box .transaction-right .cont1-box .item-number{
        flex: 1.5;    
    }    
    .transaction-foot{     
        margin-top: .4rem;   
        padding: 0 0 .2rem;        
    }
    .transaction-foot .cont-box{
        padding: 0 0 .2rem;
        /* background: #131E30; */
    }
    .transaction-foot .tab-box{
        display: flex;
        justify-content: space-around;
        align-items: center;       
        color: #fff;
        font-size: .24rem;
        /* background: rgba(22, 35, 53,.6); */
    }
    .transaction-foot .tab-box .tab{
        position: relative;
        flex: 1;
        /* width: 33.33%; */
        /* height: .54rem; */
        color: #fff; 
        font-size: .24rem;
        line-height: .54rem;
        text-align: center;
    }
    .transaction-foot .tab-box .tab1{
        flex: 1.5;
    }
    .transaction-foot .tab-box .active{     
        color:#2CAADE;       
        font-size: .26rem;  
        /* background: url('../assets/choice.png') no-repeat center center;
        background-size: 100% 100%; */
    }
    .transaction-foot .tab-box .active::after {
        position: absolute;
        left: 50%;
        bottom: -.12rem;
        content: '';
        width: .4rem;
        height: 2px;
        margin-left: -.2rem;
        background: #218adc;
    }
    /* .transaction-foot .tab-box .active::after{
        position: absolute;
        left: 50%;
        bottom: -4px;
        content: '';
        width: 20px;
        height: 2px;  
        margin-left: -10px;  
        background: #218ADC;
    } */
    .transaction-foot .cont-box .list{
        margin-top: 20px;
    }
    .transaction-foot .cont-box .list .list-head{
        display: flex;
        align-items: center;
    }
    .transaction-foot .cont-box .list .buy{
        padding: 1px 4px;
        color: #fff;
        font-size: 12px;
        border-radius: 6px;
        background: #00c483;
    }
    .transaction-foot .cont-box .list .sell{
        background: #d85656;
    }
    .transaction-foot .cont-box .list .type{    
        padding: 0 10px 0 8px;
        color: #000;
        font-weight: bold;
    }
    .transaction-foot .cont-box .list .type span{
        color: #b5b5b5;
        font-size: 13px;
        font-weight: normal;
    }
    .transaction-foot .cont-box .list .date{
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .time{
        flex: 1;
        padding-left: 10px;
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .btn-cancle{
        padding: 4px 8px;
        color: #218adc;
        font-size: 12px;
        border: 1px solid #218adc;
        border-radius: 4px;
    }
    .transaction-foot .cont-box .list .status{
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .list-body .list-item{
        /* display: flex;
        align-items: center; */
        margin-top: 10px;
        color: #7f7f7f;
    }
    .transaction-foot .cont-box .list .list-body .list-item-right{
        flex: 1;
        margin-top: 10px;        
    }
    .transaction-foot .cont-box .list .list-body .t2{
        margin-top: 10px;
    }
    .transaction-foot .cont-box .cont1{
        margin-top: .1rem;
        padding: 16px 12px;
        color: #e2e2e2;
        font-size: .28rem;
        background: rgba(22, 35, 53,.3);       
    }
    .transaction-foot .cont-box .cont2{
        padding: 12px 12px 0;
        background: #162335;
    }
    .transaction-foot .cont-box .cont2 .ul-box .li{
        display: flex;
        align-items: center;
        padding-bottom: 18px;
        color: #666;
        font-size: .28rem;
    }
    .transaction-foot .cont-box .cont2 .ul-box .t2{
        flex: 1;
        text-align: right;
    }    
    /* 左侧弹窗 */
    .alert-bz-wrap{
        position: fixed;
        top: 0;
        z-index: 1000;
        width: 5.4rem;
        height: 100%;         
        background: rgba(26, 36, 63,.9);
        overflow: hidden;
        animation: turn .5s linear;
    }
    @keyframes turn {
        0% {            
            width: .8rem;
        }
        20% {            
            width: 1.6rem;
        }
        40% {             
             width: 2.4rem;
        }
        60% {             
             width: 3.2rem;
        }
        80% {             
             width: 4rem;
        }
        100% {             
             width: 5.4rem
        }        
    } 
    .alert-bz-wrap .alert-box{
        position: absolute;
        top: 0;
        bottom: 0;    
        z-index: 999;    
        width: 100%;
        height: auto;        
    }
    .alert-bz-wrap .alert-box .alert-li{
        display: flex;
        align-items: center;
        width: 100%;
        height: 1rem;
        padding: 0 .44rem;
        color: #fff;
        font-size: .26rem;
        line-height: 1rem;
        border-bottom: 1px solid #858585;
        box-sizing: border-box;
    }    
    .alert-bz-wrap .alert-box .alert-li:last-child{
        border: none;
    }
    .alert-bz-wrap .alert-box .alert-li .money{
        flex: 1;
        color: #00B464;
        text-align: right;
    }
    .alert-bz-wrap .alert-box .alert-li .money.red{
        color: #FA4D56;        
    }
    .alert-bz-wrap .alert-box .icon{
        margin-right: .38rem;
        width: .58rem;
        height: .58rem;
    }
    .alert-bz-wrap .alert-btn{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1.3rem;
        color: #fff;
        font-size: .36rem;
        line-height: 1.3rem;
        border-top: 2px solid #3A4560;
        background: #1A243F;
        text-align: center;
    }
    .alert-pay{
        position: absolute;
        left: 1.3rem;
        right: 1.18rem;
        top: 50%;
        z-index: 1000;
        width: auto;        
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-pay .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-pay .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-pay .cont{
        max-height: 6rem;
        padding: 0 .8rem .72rem .72rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }
    .alert-pay{
        background: #1a243f;
    }
    .alert-pay .alert-head{
        padding: .5rem .4rem;
        font-size: .28rem;
        border-bottom: 1px solid #858585;
    }
    .alert-pay .alert-btn{
        padding: .3rem 0;
        color: #2CAADE;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2{
        position: absolute;
        left: 1rem;
        right: 1rem;
        top: 50%;
        z-index: 1000;
        width: auto;        
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-wrap2 .cont{
        max-height: 6rem;
        padding: 0 .4rem .72rem .36rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }  
    .pwd-alert-box{
        position: fixed;
        left: .5rem;
        right: .5rem;
        top: 50%;
        z-index: 1000;
        width: auto;  
        padding: .26rem .46rem .68rem .46rem;      
        background: rgba(55, 76 ,124,.9);
        border-radius: .07rem;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .pwd-alert-box .alert-head{
        position: relative;
        padding: 0 .06rem;
        color: #fff;
        font-size: .28rem;
        text-align: center;
    }
    .pwd-alert-box .close{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .24rem;
        height: .24rem;
    }
    .pwd-alert-box .pwd-box{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .5rem;
        border: 1px solid #fff;
    }
    .pwd-alert-box .pwd-box .pwd{
        flex: 1;
        height: .7rem;        
    }
    .pwd-alert-box .pwd-box .pwd .input{
        width: 100%;
        height: .7rem;
        color: #fff;
        font-size: .4rem;
        border-right: 1px solid #fff;
        background: #374C7C;
        text-align: center;
        box-sizing: border-box;
        border-radius: 0;
        font-weight: bold;
        outline: none;
    }
    .pwd-alert-box .pwd-box .pwd:last-child .input{
        border-right: none;
    }  
    .alert-xj-box{
        position: absolute;
        bottom: 0;
        z-index: 9999;
        width: 100%;
        background: #131E30;
    }
    .alert-xj-box .alert-item{
        width: 100%;
        height: 48px;
        color: #fff;
        line-height: 48px;
        background: #162335;
        text-align: center;
    }
    .alert-xj-box .alert-item.xj{
        border-bottom: 1px solid #666;
    }
    .alert-xj-box .alert-item.active{
        color: #218adc;
    }
    .alert-xj-box .btn-cancle{
        margin-top: 6px;
    }
    .go-top{
        bottom: 1.3rem;
    }
</style>


// WEBPACK FOOTER //
// src/pages/transaction.vue